<template>
  <div v-if="value">
    <el-row :gutter="20" type="flex" class="mb-2 pt-0" align="bottom">
      <el-col :span="10">
        <!-- Zip Code -->
        <v-text-field
          v-model="value.code"
          v-mask="
            communities[0] === 'fll-open-brazil'
              ? 'XXXXXXXXXXXXXXXXXXXX'
              : ['#####-###']
          "
          class="tournament-black--text fill"
          color="tournament-black"
          :class="
            !editing
              ? 'tournament-black--text translucid'
              : 'tournament-black--text'
          "
          :label="$t('signup.zip_code')"
          :disabled="!editing"
          @blur="
            communities[0] !== 'fll-open-brazil'
              && !value.address
              && searchAddress()
          "
        >
          <el-button
            v-if="communities[0] !== 'fll-open-brazil'"
            slot="append"
            :disabled="!editing"
            icon="el-icon-search"
            :loading="loadingAddress"
            style="background: transparent !important; border: none !important"
            @click="searchAddress"
          />
        </v-text-field>
      </el-col>

      <!-- Address -->
      <el-col :span="14">
        <v-text-field
          v-model="value.address"
          class="tournament-black--text fill"
          :class="
            !editing
              ? 'tournament-black--text translucid'
              : 'tournament-black--text'
          "
          color="tournament-black"
          :label="$t('signup.address')"
          :disabled="!editing"
        />
      </el-col>
    </el-row>

    <el-row :gutter="20" type="flex" class="mb-2" align="bottom">
      <!-- Address Number -->
      <el-col :span="10">
        <v-text-field
          v-model="value.number"
          class="tournament-black--text fill"
          :class="
            !editing
              ? 'tournament-black--text translucid'
              : 'tournament-black--text'
          "
          color="tournament-black"
          :label="$t('signup.number')"
          :disabled="!editing"
        />
      </el-col>

      <!-- Neighborhood -->
      <el-col :span="14">
        <v-text-field
          v-model="value.district"
          class="tournament-black--text fill"
          :class="
            !editing
              ? 'tournament-black--text translucid'
              : 'tournament-black--text'
          "
          color="tournament-black"
          :label="$t('signup.neighborhood')"
          :disabled="!editing"
        />
      </el-col>
    </el-row>

    <el-row :gutter="20" type="flex" class="mb-0" align="bottom">
      <!-- City -->
      <el-col :span="18">
        <v-text-field
          v-model="value.city"
          class="tournament-black--text fill"
          :class="
            !editing
              ? 'tournament-black--text translucid'
              : 'tournament-black--text'
          "
          color="tournament-black"
          :label="$t('signup.city')"
          :disabled="!editing"
        />
      </el-col>

      <!-- State -->
      <el-col :span="6">
        <v-text-field
          v-model="value.state"
          class="tournament-black--text fill"
          :class="
            !editing
              ? 'tournament-black--text translucid'
              : 'tournament-black--text'
          "
          color="tournament-black"
          :label="$t('signup.state')"
          :disabled="!editing"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Axios from "axios";

export default {
  name: "AddressForm",

  props: {
    value: {
      type: Object,
    },
    editing: {
      type: Boolean,
      required: true,
    },
    communities: {
      type: Array,
      required: false,
    },
  },

  data: function () {
    return {
      loadingAddress: false,
    };
  },

  created() {
    // Keep safe when parent pass a undefined as prop
    if (!this.value) {
      this.$emit("input", {
        address: null,
        code: "",
        number: null,
        district: null,
        city: null,
        state: null,
      });
    }

    this.communities = this.communities || [];
  },

  methods: {
    searchAddress: function () {
      const code = this.value.code;

      // Skip if no code present
      if (!code) return;

      // Query brazils CEP service to fetch data
      this.loadingAddress = true;
      Axios.get(
        "https://apps.widenet.com.br/busca-cep/api/cep/" + code + ".json",
      ).then(
        (res) => {
          this.loadingAddress = false;
          const address = res.data;
          if (address.status != 200) {
            this.$message.warning(address.message);
            return;
          }

          this.value.code = address.code;
          this.value.city = address.city;
          this.value.state = address.state;
          this.value.address = address.address.split(" - ")[0];
          this.value.district = address.district;
        },
        (err) => {
          this.loadingAddress = false;
          this.$message.warning(
            "Tentamos, mas não foi possível carregar dados do CEP automaticamente",
          );
          console.error(err);
        },
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AddressForm.vue